import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
export const ChipContainer = ({ children, ...rest }) => {
    const tokens = useTokens();
    return (React.createElement(Flex, { mt: tokens.Spacing05, gap: tokens.Spacing05, flexWrap: "wrap", ...rest }, children));
};
